module.exports = __webpack_public_path__ + "static/media/demo-background.2f1a6cde.svg";